export default "__VITE_ASSET__DqGLwkyb__"